// Test IDs for the ZMEX Customer Portal.
// Keys use camelCase, values use kebab-case `<feature>-<element>`.

export const PORTAL = {
  page: 'portal-page',
  headerLogo: 'portal-header-logo',
  headerHelp: 'portal-header-help',
  headerLangToggle: 'portal-header-lang-toggle',
  headerPhone: 'portal-header-phone',
  headerMobileMenuBtn: 'portal-header-mobile-menu-btn',
  heroHeading: 'portal-hero-heading',
  heroSubtitle: 'portal-hero-subtitle',
  signInCard: 'portal-signin-card',
  signInHeading: 'portal-signin-heading',
  signInInput: 'portal-signin-input',
  signInInputError: 'portal-signin-input-error',
  signInSubmitBtn: 'portal-signin-submit-btn',
  signInSuccess: 'portal-signin-success',
  payCard: 'portal-pay-card',
  payHeading: 'portal-pay-heading',
  payInput: 'portal-pay-input',
  payInputError: 'portal-pay-input-error',
  paySubmitBtn: 'portal-pay-submit-btn',
  paySuccess: 'portal-pay-success',
  benefitViewInvoices: 'portal-benefit-view-invoices',
  benefitMakePayments: 'portal-benefit-make-payments',
  benefitManageAutopay: 'portal-benefit-manage-autopay',
};

export const VERIFY = {
  page: 'verify-page',
  heading: 'verify-heading',
  destination: 'verify-destination',
  codeBox: (i) => `verify-code-box-${i}`,
  submitBtn: 'verify-submit-btn',
  resendBtn: 'verify-resend-btn',
  resendCountdown: 'verify-resend-countdown',
  changeContactBtn: 'verify-change-contact-btn',
  returnLoginBtn: 'verify-return-login-btn',
  errorMsg: 'verify-error',
  loadingIndicator: 'verify-loading',
  lockedState: 'verify-locked-state',
};

export const DASHBOARD = {
  page: 'dashboard-page',
  loading: 'dashboard-loading',
  selectorAccount: 'dashboard-selector-account',
  selectorLocation: 'dashboard-selector-location',
  greeting: 'dashboard-greeting',
  paymentReminder: 'dashboard-payment-reminder',
  paymentReminderDismiss: 'dashboard-payment-reminder-dismiss',
  contactInfoCard: 'dashboard-contact-info-card',
  contactInfoEditBtn: 'dashboard-contact-info-edit',
  contactInfoSaveBtn: 'dashboard-contact-info-save',
  contactInfoCancelBtn: 'dashboard-contact-info-cancel',
  contactInfoPhoneInput: 'dashboard-contact-info-phone-input',
  contactInfoEmailInput: 'dashboard-contact-info-email-input',
  contactInfoMailingInput: 'dashboard-contact-info-mailing-input',
  contactInfoFlash: 'dashboard-contact-info-flash',
  accountName: 'dashboard-account-name',
  serviceAddress: 'dashboard-service-address',
  accountStatus: 'dashboard-account-status',
  cardBalance: 'dashboard-card-balance',
  cardNextDue: 'dashboard-card-next-due',
  cardOpenInvoices: 'dashboard-card-open-invoices',
  cardAutopay: 'dashboard-card-autopay',
  ctaPayNow: 'dashboard-cta-pay-now',
  ctaViewInvoices: 'dashboard-cta-view-invoices',
  ctaGetSupport: 'dashboard-cta-get-support',
  billingSection: 'dashboard-billing-section',
  invoicesTable: 'dashboard-invoices-table',
  paymentsTable: 'dashboard-payments-table',
  invoiceRow: (id) => `dashboard-invoice-row-${id}`,
  paymentRow: (id) => `dashboard-payment-row-${id}`,
  serviceInfoCard: 'dashboard-service-info-card',
  supportSection: 'dashboard-support-section',
  supportCategoryBtn: (key) => `dashboard-support-category-${key}`,
  accountSelectorLabel: 'dashboard-account-selector-label',
  signOutBtn: 'dashboard-sign-out-btn',
  accountPickerCard: (id) => `dashboard-account-pick-${id}`,
  payInvoiceBtn: (id) => `dashboard-pay-invoice-btn-${id}`,
  autopaySetupBtn: 'dashboard-autopay-setup-btn',
  autopayDisableBtn: 'dashboard-autopay-disable-btn',
};

export const PAYMENT_MODAL = {
  modal: 'payment-modal',
  closeBtn: 'payment-modal-close-btn',
  submitBtn: 'payment-modal-submit-btn',
  amount: 'payment-modal-amount',
  invoiceNumber: 'payment-modal-invoice-number',
  errorMsg: 'payment-modal-error',
  successState: 'payment-modal-success',
  successDoneBtn: 'payment-modal-success-done-btn',
  processing: 'payment-modal-processing',
};

export const AUTOPAY_MODAL = {
  modal: 'autopay-modal',
  closeBtn: 'autopay-modal-close-btn',
  submitBtn: 'autopay-modal-submit-btn',
  errorMsg: 'autopay-modal-error',
  successState: 'autopay-modal-success',
  successDoneBtn: 'autopay-modal-success-done-btn',
};

export const SUPPORT = {
  newPage: 'support-new-page',
  newForm: 'support-new-form',
  inputSubject: 'support-input-subject',
  inputMessage: 'support-input-message',
  inputPhoto: 'support-input-photo',
  selectAccount: 'support-select-account',
  selectLocation: 'support-select-location',
  selectCategory: 'support-select-category',
  radioText: 'support-radio-text',
  radioEmail: 'support-radio-email',
  radioPhone: 'support-radio-phone',
  submitBtn: 'support-submit-btn',
  errorMsg: 'support-error',
  confirmationPage: 'support-confirmation-page',
  confirmationNumber: 'support-confirmation-number',
  confirmationBackDashboardBtn: 'support-confirmation-back-dashboard-btn',
  confirmationViewRequestsBtn: 'support-confirmation-view-requests-btn',
  listPage: 'support-list-page',
  listItem: (id) => `support-list-item-${id}`,
  listItemView: (id) => `support-list-item-view-${id}`,
  detailPage: 'support-detail-page',
  detailStatus: 'support-detail-status',
  detailConfirmation: 'support-detail-confirmation',
  followUpForm: 'support-followup-form',
  followUpMessage: 'support-followup-message',
  followUpPhoto: 'support-followup-photo',
  followUpSubmitBtn: 'support-followup-submit-btn',
};
